import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchCustomDomains } from 'redux/actions';
import get from 'lodash/get';
import { useRouteMatch } from 'react-router-dom';

const useDomains = (storeId, domainStatusSection = false) => {
  const dispatch = useDispatch();
  const { domains } = useSelector((state) => state.customDomain);
  const storeDomains = get(domains, storeId, []);
  const match = useRouteMatch();
  const [isFetchingDomains, setIsFetchingDomains] = useState(true);

  useEffect(() => {
    let isCurrent = true;
    const getStoreDomains = async () => {
      setIsFetchingDomains(true);
      await dispatch(fetchCustomDomains(storeId, true, domainStatusSection));
      if (isCurrent) setIsFetchingDomains(false);
    };
    getStoreDomains();
    return () => {
      isCurrent = false;
    };
  }, [storeId, dispatch, match.path, domainStatusSection]);

  return { domains: storeDomains, isFetchingDomains };
};

export default useDomains;
